'use client'

import PlaceholderImg from "@/images/dummy/placeholder-product.png"
import {useState} from "react";
import {cn} from "@/lib/utils";
import Image from "next/image";
import {Skeleton} from "@/components/ui/skeleton";

interface FallbackImageProps {
    image: {
        src: string;
        alt?: string;
        width?: number;
        height?: number;
    } | null
    className?: string;
    border?: boolean;
    priority?: boolean;
}

export default function FallbackImage({ image, className, border = true, priority = true }: FallbackImageProps) {
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const [imageUrl, setImageUrl] = useState<string | undefined>(image?.src);

    return(
        <>
            {!isImageLoaded && (
                <div className="w-full h-full flex items-center justify-center">
                    <Skeleton className="h-3/4 w-3/4" />
                </div>
            )}
            <Image
                className={cn(`w-full ${border ? "border" : ""} object-scale-down p-5`, className)}
                src={imageUrl === "" || !imageUrl ? PlaceholderImg.src : imageUrl}
                alt={PlaceholderImg.src}
                fill={true}
                onLoad={() =>  setIsImageLoaded(true)}
                onError={() => setImageUrl(PlaceholderImg.src)}
                priority={priority}
            />
        </>
    );
}